const FEEDBACK_URL = 'https://feedback.skribble.com'

export function useFeaturebaseSso() {
  const userStore = useUserStore()
  const businessStore = useBusinessStore()
  const openFeaturebase = async (returnTo?: string) => {
    const { featurebaseRepository } = useLegacyApi()
    const destination = returnTo || FEEDBACK_URL

    try {
      const { token } = await featurebaseRepository.getSsoToken({
        name: `${userStore.firstName} ${userStore.lastName}`.trim() || userStore.email,
        email: userStore.email,
        userId: userStore.id,
        companies: businessStore.id ? [{ id: businessStore.id, name: businessStore.name }] : [],
      })
      window.open(`${FEEDBACK_URL}/api/v1/auth/access/jwt?jwt=${token}&return_to=${encodeURIComponent(destination)}`)
    } catch {
      window.open(destination)
    }
  }

  return { openFeaturebase }
}
